export function validateBusinessDateRange(value: readonly string[] | null | undefined): string {
  if (!value || value.length !== 2) return ''
  return value[1]! < value[0]! ? '结束日期不能早于开始日期' : ''
}
